import MarkdownIt from 'markdown-it'
import type { AppMessage } from '@/composables/useSamGpt/types'

export const getTimeStamp = () => {
  const currentDate = new Date()
  return currentDate.toUTCString()
}

export const getConversationId = (screen: string, listingId: string, domainUserId: string) => {
  return `${screen}/${listingId || 'general'}/${domainUserId}`
}

export const generateMessageId = (screen: string, listingId: string, domainUserId: string) => {
  return `${screen}/${listingId || 'general'}/${domainUserId}/${Date.now()}`
}

export const parseMessage = (content: string) => {
  const md = new MarkdownIt({
    breaks: true,
    html: true
  })
  return md.render(content)
}

export const parseMessageToHtml = (message:any) => {
  let attachmentsLinks = ''

  if (message.attachments) attachmentsLinks = message.attachments.map(attachment => `${attachment.description || 'adjunto'}(${attachment.url || attachment.media_url})`).join('<br>')

  if (attachmentsLinks) return `${attachmentsLinks} <br> ${message.internalBody || message.body || message.text}`

  return message.internalBody || message.body || message.text
}

export const getSalesforceAuthorName = (author: string) => {
  if (author === 'bot') return 'Sam'

  return 'Usuario'
}

export const convertConversationToHtml = (name: string, messages: AppMessage[]) => {
  const projectCode = name.split('/')[1]
  const projectName = localStorage?.getItem(`sam_gpt_listing_${projectCode}`) || ''
  const content = `
    <section>
      <h1>
        <b>${projectName}[${projectCode}]</b>
      </h1>
      ${messages.map(message => `
      <div>
        <b>${getSalesforceAuthorName(message.author)} (${message.timestamp})</b>: ${parseMessageToHtml(message)}
      </div>
      <br>
      `).join('')}
    </section>
  `

  return content
}
